/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { Parser as HtmlToReactParser } from 'html-to-react';

import Grid from '@mui/material/Grid';
// import Logo from '../logo';
import { useStyles } from './styles';
import getCommonUIStyles from '../../../commons/uiStyles';
import { useAppStore } from '../../../store/models/app';

import { ECAL_TERMS_URL, ECAL_PRIVACY_URL } from '../../../commons/utils/constants';

const htmlToReactParser = new HtmlToReactParser();

function TitleHeader (props) {
    const {
        widget = {},
        widgetTheme = {},
        title = '',
        subtitle = '',
        error,
        termsValue,
        privacyValue,
    } = props;

    const appStore = useAppStore();
    const [hasCustomCSS , setHasCustomCSS] = useState(appStore.customCss);

    useEffect(() => {
        setHasCustomCSS(appStore.customCss);
    }, [appStore.observed.customCss]);
 
    const classes = useStyles({
        widget,
        widgetTheme,
        error,
        hasCustomCSS,
        commonUIStyles: getCommonUIStyles({
            widget,
            widgetTheme,
        }),
    });

    function renderSubtitle () {
        if (termsValue && privacyValue) {
            const ECAL_TERMS_CUSTOM = subtitle?.split('{termsValue}')[0];
            const ECAL_TERMS_AND = subtitle?.split('{termsValue}')[1]?.split('{privacyValue}')[0];
            const ECAL_TERMS_PERIOD = subtitle?.split('{termsValue}')[1]?.split('{privacyValue}')[1];

            return (
                <React.Fragment>
                    <div
                        className={
                            classNames([
                                classes.termsAndPrivacyBox,
                                'ecal-terms'
                            ])
                        }
                    >
                        <p
                            id="ecal-terms-and-privacy-label"
                            className={classes.termsAndPrivacyPTag}
                        >
                            <span className="ecal-terms-custom">
                                <span>
                                    { ECAL_TERMS_CUSTOM }
                                </span>
                            </span>
                            <span className="ecal-terms-fixed">
                                <a
                                    id="ecal-terms"
                                    href={ECAL_TERMS_URL}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <span>
                                        { htmlToReactParser.parse(termsValue) }
                                    </span>
                                </a>
                                { ECAL_TERMS_AND }
                                <a
                                    id="ecal-privacy"
                                    href={ECAL_PRIVACY_URL}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <span>
                                        { htmlToReactParser.parse(privacyValue) }
                                    </span>
                                </a>
                                { ECAL_TERMS_PERIOD }
                            </span>
                        </p>
                    </div>
                </React.Fragment>
            );
        }

        if (subtitle) {
            return (<React.Fragment>
                <p id="ecal-intro-label" className={classNames(['ecal-intro-label', classes.intro])}>
                    { htmlToReactParser.parse(subtitle) }
                </p>
            </React.Fragment>);  
        }

        return (<React.Fragment></React.Fragment>);   
    }

    return (
        <Grid
            className={
                classNames([
                    classes.header,
                    'ecal-accent-color',
                    'ecal-panel-header-container',
                ])
            }
        >
            { title && <span id="ecal-title-heading" className={classNames(['ecal-panel-title', classes.title])}>
                { title }
            </span> }
            { renderSubtitle() }

            <hr className={classes.lineDivider}/>
        </Grid>
    );
}


TitleHeader.propTypes = {
    widget: PropTypes.any,
    widgetTheme: PropTypes.any,
    title: PropTypes.string,
    subtitle: PropTypes.string,
};

export default observer(TitleHeader);